module.exports = __webpack_public_path__ + "img/cedula_reves.3f426285.png";